module.exports = __webpack_public_path__ + "images/emoji/anchor.009618cb81b080dba70d.png";